import { useLocation } from "react-router-dom";
import { resolvePageName } from "../nav/breadcrumb.tsx";
import { useFavorites } from "../../hooks/useFavorites.ts";
import { StatusIcon } from "./statusIcon.tsx";
import styles from "./favoriteButton.module.scss";

export function FavoriteButton() {
  const { pathname, search } = useLocation();
  const pageName = resolvePageName(pathname, search);
  const { isFavorite, toggleFavorite } = useFavorites();

  if (!pageName) return null;

  const active = isFavorite(pageName);

  return (
    <button
      onClick={() => toggleFavorite(pageName)}
      className={`${styles.favBtn}${active ? ` ${styles.favBtnActive}` : ""}`}
      title={active ? "Remove from favorites" : "Add to favorites"}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={active}
    >
      <StatusIcon kind={active ? "starFilled" : "star"} size={16} />
    </button>
  );
}
